import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/landing/src/components/home/figma-homepage.tsx");
